import * as React from "react";
const SvgQrCodeScannerBottomRightCorner = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 25", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "white", strokeWidth: 2, d: "M24 0v20a4 4 0 0 1-4 4H0", opacity: 0.7 }));
export default SvgQrCodeScannerBottomRightCorner;
